<template>
  <WorkGenericPicker
    v-model="inputVal"
    v-bind="$props"
    :path="customPath ? customPath : 'devices'"
    :item-text="
      customItemText ? customItemText : (item) => defaultItemText(item)
    "
    :api-get-response-item-text="
      customItemText ? customItemText : (item) => defaultItemText(item)
    "
    :headers="internalHeaders"
    :load-generic-id="loadGenericId ? loadGenericId : _handleDefaultLoad"
    v-on="$listeners"
  >
    <template #header>
      <slot name="header">
        {{ $t('Components.sentences.chooseDevice') }}
      </slot>
    </template>

    <template #tooltip>
      <slot name="tooltip">
        {{ $t('Components.sentences.chooseDevice') }}
      </slot>
    </template>

    <template #filters>
      <slot name="filters">
        <w-row>
          <w-column cols="auto">
            <WorkContactPicker
              :label="$t('Common.owner')"
              :mandatory-filters="{ entryType: 'company' }"
              item-text="data.shortCaption"
              searchKey="owner"
              clearable
              with-input-field
              :return-object="false"
            />
          </w-column>
          <w-column cols="auto">
            <w-autocomplete
              :label="$t('Common.productLinked')"
              :items="yesOrNo"
              searchKey="hasProductOnly"
            />
          </w-column>
        </w-row>
      </slot>
    </template>

    <template #item="{ item }">
      {{ defaultItemText(item) }}
    </template>

    <template #append-outer-actions>
      <slot name="append-outer-actions" />
    </template>
  </WorkGenericPicker>
</template>

<script>
// components
import WorkContactPicker from '@/components/global_components/pickers/contact_picker/WorkContactPicker';
import WorkGenericPicker from '@/components/global_components/pickers/generic_picker/WorkGenericPicker';

// mixins
import genericPickerProps from '@/components/global_components/pickers/generic_picker/mixins/generic-picker-props';
import genericPickerDialogProps from '@/components/global_components/pickers/generic_picker/mixins/generic-picker-dialog-props';

// services and utils
import deviceService from '@/services/device-service';
import { formatBool } from '@/utils/shared';
import SIMPLE_YES_NO from '@/utils/enum/SIMPLE_YES_NO';

export default {
  name: 'DevicePicker',
  components: { WorkContactPicker, WorkGenericPicker },
  mixins: [genericPickerProps, genericPickerDialogProps],
  props: {
    customPath: { type: String, required: false },
    customItemText: { type: [String, Function], required: false },
    exportComponent: { type: String, default: "DevicesForm"}
  },
  data() {
    return {
      yesOrNo: Object.values(SIMPLE_YES_NO),
    };
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    internalHeaders() {
      if (this.headers) {
        return this.headers;
      }

      return [
        { text: this.$t('Common.serialNumber'), value: 'serialNumber' },
        { text: this.$t('Common.label'), value: 'label' },
        { text: this.$t('Common.product'), value: 'productLabel' },
        { text: this.$t('Common.owner'), value: 'currentOwner' },
        { text: this.$t('Common.contact'), value: 'contactName' },
        { text: this.$t('Common.maintenance'), value: 'hasMaintenance', presentWith: formatBool },
      ];
    },
  },
  methods: {
    async _handleDefaultLoad(deviceId) {
      let response = await deviceService.loadData(deviceId);
      return response.data;
    },
    defaultItemText(item) {
      if (this.customItemText) 
        return this.customItemText(item);
       
      return !item?.data?.label
        ? item?.data?.serialNumber
        : item?.data?.serialNumber + ' - ' + item?.data?.label;
    },
  },
};
</script>
